import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useEventsScope } from '../contexts/EventsScopeContext';

export const useUpdateEventPublishedMutation = (options = {}) => {
  const queryClient = useQueryClient();
  const { api, queryKeys } = useEventsScope();

  return useMutation({
    mutationFn: async ({ eventId }) => {
      const result = await api.updateEventPublished(eventId);
      if (!result.success) {
        throw new Error(result.message || 'Failed to update published status');
      }
      return result.data;
    },
    onSuccess: async (...args) => {
      await queryClient.invalidateQueries({ queryKey: queryKeys.all });
      if (options.onSuccess) {
        options.onSuccess(...args);
      }
    },
    ...options,
  });
};
